import { h } from 'preact';
import { TextFieldEntry } from '../entries/TextFieldEntry';

export class CallActivityPropertiesProvider {
  constructor(lf, i18n) {
    this._lf = lf;
    this._i18n = i18n;
  }

  isApplicable(elementType) {
    return elementType === 'epx:CallActivity';
  }

  getGroups(element) {
    const { lf, i18n } = { lf: this._lf, i18n: this._i18n };
    const props = element.properties || {};
    const id = element.id;

    const update = (key, value) => {
      lf.setProperties(id, { [key]: value });
      lf.emit('node:properties-change', { id, properties: { [key]: value } });
    };

    return [
      {
        id: 'callActivity',
        label: i18n.callActivity || 'Call Activity',
        entries: [
          {
            id: 'calledElement',
            component: () => (
              <TextFieldEntry
                id="epx-called-element"
                label={i18n.calledElement || 'Called Element'}
                value={props.calledElement || ''}
                onChange={(val) => update('calledElement', val)}
              />
            ),
          },
        ],
      },
    ];
  }
}
